import React from 'react';
import { FUNDING_STATUS } from '../treasury.constants';
import styles from './styles/statusPill.module.scss';

const STATUS_LABELS = {
    [FUNDING_STATUS.HEALTHY]: 'Healthy',
    [FUNDING_STATUS.AT_RISK]: 'At Risk',
    [FUNDING_STATUS.DEPOSIT_NEEDED]: 'Deposit Needed',
};

const STATUS_CLASS = {
    [FUNDING_STATUS.HEALTHY]: styles.healthy,
    [FUNDING_STATUS.AT_RISK]: styles.atRisk,
    [FUNDING_STATUS.DEPOSIT_NEEDED]: styles.depositNeeded,
};

/**
 * Coloured status pill for Funding Recommendation. Defaults to "Healthy"
 * when the status is missing so the layout doesn't collapse.
 */
function StatusPill({ status }) {
    const safeStatus = status || FUNDING_STATUS.HEALTHY;
    const label = STATUS_LABELS[safeStatus] || STATUS_LABELS[FUNDING_STATUS.HEALTHY];
    const cls = STATUS_CLASS[safeStatus] || STATUS_CLASS[FUNDING_STATUS.HEALTHY];

    return <span className={`${styles.pill} ${cls}`}>{label}</span>;
}

export default StatusPill;
